import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { ConfigPedidoModule } from '../../../../configuracoes/app/pedido';

import { PedidoNaoLiberadoCardInfoClienteInadimplenteComponent } from './pedido-nao-liberado-card-info-cliente-inadimplente.component';

@NgModule({
    imports: [
        SharedModule,
        ConfigPedidoModule
    ],
    declarations: [
        PedidoNaoLiberadoCardInfoClienteInadimplenteComponent
    ],
    exports: [
        PedidoNaoLiberadoCardInfoClienteInadimplenteComponent
    ]
})
export class PedidoNaoLiberadoCardInfoClienteInadimplenteModule { }
